var React = require('react');

function KeypadAc (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"currentColor","strokeWidth":"1.7"},[React.createElement("path",{"d":"M16.469 8.5a7.969 7.969 0 1 1-15.938 0 7.969 7.969 0 0 1 15.938 0z","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"M3.719 8.5s.797-2.656 2.39-2.656 3.188 5.312 4.782 5.312S13.28 8.5 13.28 8.5","key":1})]));
}

KeypadAc.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17"};

module.exports = KeypadAc;

KeypadAc.default = KeypadAc;
